import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=0bcd1940&scoped=true&lang=css"

import exportComponent from "/home/runner/work/talkvox_portal_v2/talkvox_portal_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bcd1940"]])

export default __exports__